import { Box, CircularProgress, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import LangEnum from '../../../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../../../translation/TranslationContext';

const useStyles = makeStyles()({
  circularProgress: {
    color: '#00000061',
  },
});

const PacksMenuLoading = () => {
  const { classes } = useStyles();
  const { translate } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        columnGap: '12px',
        marginTop: 3,
      }}
    >
      <CircularProgress size={16} className={classes.circularProgress} />
      <Typography color="textSecondary">{translate(LangEnum.GLOBAL_LOADING_RESULTS)}...</Typography>
    </Box>
  );
};

export default PacksMenuLoading;
